// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"83fccb12","453":"bcee38f6","771":"baed4c67","801":"3095ee24","826":"8bd41bd9","925":"fa495a8d","935":"837b1df6"}[chunkId] + ".chunk.js";
};